import React, { Component } from 'react';

class Breadcrumb extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item active" aria-current="page">
                                        HL7 Messages
                                    </li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">HL7 Messages</h2>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Breadcrumb;
